import React, { useRef } from "react";
import styles from "../Footer/Footer.module.css";
import { Grid } from "@material-ui/core";
import { useEffect } from "react";
import btn_arrow from "../../assets/images/btn-arrow-xl.svg";
import {
  InputLabel,
  TextField,
  MenuItem,
  FormControl,
  Select,
} from "@material-ui/core";
import { debounce } from "debounce";
import formMailChange from "../../assets/images/form-mail-golden.svg";
import formMail from "../../assets/images/form-mail.svg";
import newsletter_arrow from "../../assets/images/newsletter-gray.svg";
import newsletter_arrow_golden from "../../assets/images/newsletter-golden.svg";

import { sender } from "../../utils/sendMail";
import subscribeViaEmail from "../../services/setRequest/subscribeViaEmail";
import {
  decrypt,
  encrypt,
  generateSecreteKey,
  createRequestIds,
} from "../../services/encryptionDecryptionService";
import {
  CIN_NUMBER,
  EMAIL_PLACEHOLDER,
  TOAST_COMMON_ERROR,
  TOAST_SUBSCRIBE_EMAIL,
  encryptDecryptKey,
} from "../../constants/Constants";
import { HOST_URL, SITE_ID } from "../../services/apiConstants";
import { getInvestorCharter } from "../../services/request/home";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import toast from "react-hot-toast";
import { hashWithSHA256, isEmailValid } from "../../utils/commonFunctions";

export default function Footer() {
  const [emailErrorMsg, setEmailErrorMsg] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [changeMail, setChanEemail] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState(false);
  const [errorFlagSubscribe, setErrorFlagSubscribe] = React.useState(false);
  const [errorMsgSubscribe, setErrorMsgSubscribe] = React.useState("");

  const [requestId, setRequestId] = React.useState(0);
  const [requestIDs, setRequestIds] = React.useState([]);
  const [charterPDF, setCharterPDF] = React.useState("");
  const [dimensions, setDimensions] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  function handleEmailChange(event) {
    const email = event.target.value;
    setEmail(email);
    if (emailErrorMsg === true) {
      setEmailErrorMsg(false);
    }
  }

  function handleImageChangeFormMail() {
    setChanEemail(true);
  }
  function handleChangeImageFormMail() {
    setChanEemail(false);
  }
  useEffect(() => {
    const charter = getInvestorCharter();
    charter.then((data) => {
      if (data.data.investorCharter.length > 0) {
        setCharterPDF(data.data.investorCharter[0].file.item[0].value);
      }
    });

    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      // Clean up the event listener when the component unmounts
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function changeRequestId(txnId) {
    var secret = "";
    console.warn(JSON.stringify(requestIDs));
    var latest = requestIDs.filter(function (val) {
      if (val.requestId === txnId) {
        secret = val.secret.substring(
          0,
          val.secret.length - val.requestId.length
        );
        return false;
      }
      return true;
    });
    setRequestIds(latest);
    return secret;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const hashedEmail = await hashWithSHA256(email);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "emailforUpdates_submit",
      inquiryType: "",
      buttonName: "",
      email: hashedEmail, // Encrypted email of the User using SHA-256 encryption
      contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
      clientID: "",
      queryMessage: "",
      state: "",
      pageSection: "Subscribe to our Market Commentary",
      Category: "",
      FAQ: "",
    });

    if (!isEmailValid(email)) {
      setEmailErrorMsg(true);
      return;
    } else {
      handleChangeImageFormMail();
    }
    if (!email) {
      setEmailErrorMsg(true);
      return;
    } else {
      let secret = generateSecreteKey(5);
      // let reqId = createRequestIds(requestId, secret);
      // let reqIds = requestIDs;
      // reqIds.push(reqId);
      // setRequestIds(reqIds);

      let payload = {
        email: email,
      };

      let encrypted = encrypt(payload, encryptDecryptKey);

      let response = await subscribeViaEmail(JSON.stringify(encrypted));

      // Assuming `response.data` is the encrypted message
      let decryptedData = decrypt(response.data.part1, encryptDecryptKey);

      console.log("Subscribe", decryptedData);
      if (decryptedData.status === "success") {
        toast.success(TOAST_SUBSCRIBE_EMAIL);
        setErrorFlagSubscribe(false);
        setEmail("");
      } else if (
        decryptedData.status === "failure" &&
        decryptedData.statusCode === 400
      ) {
        setErrorMsgSubscribe(decryptedData.message);
        setErrorFlagSubscribe(true);
        setEmail("");
        toast.error("Email id already subscribed");
      } else {
        setErrorFlagSubscribe(false);
        toast.error(TOAST_COMMON_ERROR);
      }
    }
  }

  const history = useHistory();

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  // Function to handle navigation and scroll to top
  const handleLinkClick = (path) => {
    history.push(path);
    scrollToTop();
  };

  return (
    <div className={styles.container}>
      <div className={styles.grids}>
        <Grid container spacing={3} className={styles.grid_container}>
          <Grid item xs md={3} className={styles.grid_one}>
            <p className={styles.grid_one_heading_fee_calc}>
              <a
                href="https://calculator.iciciprualternates.com/"
                target="blank"
                style={{ color: "#97291e" }}>
                <b>PMS Fee Calculator</b>
              </a>
            </p>
            <p className={styles.grid_one_heading}>
              <b>Subscribe to our Market Commentary</b>
            </p>
            <p className={styles.grid_one_para}>
              Receive monthly market updates in your inbox
            </p>
            <div className={`mailInputWrapper ${styles.inputwrapper}`}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                }}>
                <div
                  onMouseOver={handleImageChangeFormMail}
                  onMouseLeave={handleChangeImageFormMail}>
                  {changeMail ? (
                    <img src={formMailChange} alt="form-mail-golden" />
                  ) : (
                    <img src={formMail} alt="form-mail" />
                  )}
                </div>
                <div
                  className={`textFieldContainer ${styles.contactfullnameField}`}>
                  <input
                    id="email"
                    label="Email"
                    type="email"
                    // name="Email"
                    autoComplete="off"
                    // InputProps={{ disableUnderline: true }}
                    className={styles.contactTextfield}
                    placeholder={EMAIL_PLACEHOLDER}
                    required
                    value={email}
                    onChange={(e) => handleEmailChange(e)}
                    onBlur={(e) => {
                      if (!email) {
                        setChanEemail(false);
                        setEmailErrorMsg(false);
                      }
                    }}
                  />
                </div>
              </div>
              <div>
                <a
                  href="#"
                  onClick={handleSubmit}
                  onMouseOver={handleImageChangeFormMail}
                  onMouseLeave={handleChangeImageFormMail}
                  style={{
                    marginLeft: "0%",
                    marginTop: "0.5%",
                    cursor: "pointer",
                  }}>
                  {changeMail ? (
                    <img
                      src={newsletter_arrow_golden}
                      alt=""
                      className={styles.newsletter_arrow}
                    />
                  ) : (
                    <img
                      src={newsletter_arrow}
                      alt=""
                      className={styles.newsletter_arrow}
                    />
                  )}
                </a>
              </div>
            </div>
            {emailErrorMsg ? (
              <span style={{ color: "white" }}>Enter valid email address</span>
            ) : errorFlagSubscribe ? (
              <span style={{ color: "red" }}>
                {errorMsgSubscribe
                  .split(/(unsubscribe)/gi)
                  .map((part, index) => {
                    return part.toLowerCase() === "unsubscribe" ? (
                      <a
                        href="/unsubscribe-email"
                        target="blank"
                        key={index}
                        style={{
                          textDecoration: "underline",
                          color: "red",
                        }}>
                        {part}
                      </a>
                    ) : (
                      part
                    );
                  })}
              </span>
            ) : (
              ""
            )}
            {errorMsg ? <span style={{ color: "white" }}>Required</span> : ""}
            {/* <div style={{marginLeft: '85%', marginTop: '-15%'}}>
                            <img src={newsletter_arrow} alt='' className={styles.newsletter_arrow}/>
                        </div> */}
          </Grid>
          {/* <Grid item xs className={styles.grid_two}>
            <p className={styles.grid_four_heading}><b>PMS Strategies</b></p>
            <a href="/portfolio-management-service/contrarian-investing" className={styles.offering_links}>
              Contra Strategy
            </a>
            <br />
            <a href="/portfolio-management-service/flexicap" className={styles.offering_links}>
              Flexicap Strategy
            </a>
            <br />
            <a href="/portfolio-management-service/value-strategy" className={styles.offering_links}>
              Value Strategy
            </a>
            <br />
            <a href="/portfolio-management-service/largecap-strategy" className={styles.offering_links}>
              Largecap Strategy
            </a>
            <br />
            <a href="/portfolio-management-service/pipe-pms" className={styles.offering_links}>
              PIPE Strategy
            </a>
            <br />
            <p>
              <b>AIF</b>
            </p>
            <a href="/alternative-investment-funds" className={styles.offering_links}>
              Alternative Investment Funds
            </a>
            <br />

          </Grid> */}
          <Grid item xs md={1} className={styles.grid_three}>
            <p className={styles.grid_four_heading}>
              <b>Company</b>
            </p>
            <Link
              to="/about-us"
              className={styles.links}
              onClick={handleLinkClick}>
              About Us
            </Link>
            <br />
            <Link
              to="/market-insights"
              className={styles.links}
              onClick={handleLinkClick}>
              Insights
            </Link>
            <br />
            <Link
              to="/investors-corner"
              className={styles.links}
              onClick={handleLinkClick}>
              Investor Corner
            </Link>
            <br />
            <Link
              to=""
              onClick={(e) => {
                window.open(HOST_URL + charterPDF + SITE_ID, "_blank");
                handleLinkClick();
                e.preventDefault();
              }}
              style={{ cursor: "pointer" }}
              onContextMenu={(e) => {
                e.preventDefault();
              }}
              className={styles.links}>
              Investor Charter
            </Link>
            <br />
            <Link
              to="/existing-investor"
              className={styles.links}
              onClick={handleLinkClick}>
              Contact Us
            </Link>
            <br />
            <Link to="/faqs" className={styles.links} onClick={handleLinkClick}>
              FAQs
            </Link>
            <br />
            <Link
              to="/site-map"
              className={styles.links}
              onClick={handleLinkClick}>
              SiteMap
            </Link>
          </Grid>
          <Grid item xs md={3} className={styles.grid_four}>
            <p className={styles.grid_four_heading}>
              <b>Corporate Office</b>
            </p>
            <p className={styles.contact_info}>
              ONE BKC,A-Wing,13th Floor,Bandra-
              <br />
              Kurla Complex,
              <br />
              Mumbai 400 051
              {/* <br /> */}
              <p className={styles.grid_four_heading}>
                <b>Reach Out to Us</b>
              </p>
              <b>Contact Number</b> : 1800-268-0001
              <br />
              <b>Email</b> : alt@icicipruamc.com
            </p>
            <p>
              <a
                href="https://goo.gl/maps/8LNmoir3SKxgwMjV7"
                target="_blank"
                className={styles.map_button}>
                Open In Google Maps
                <span className={styles.arrow}>
                  <img src={btn_arrow} alt="btn-arrow-xl" />
                </span>
              </a>
            </p>
          </Grid>
        </Grid>
      </div>
      {/* <div className={styles.registrationnumber}>
        <p>
          ICICI Prudential Asset Management Company Limited is registered with
          SEBI as a Portfolio Manager vide registration number INP000000373
        </p>
        <p><span style={{fontWeight:"700"}}>CIN </span>: {CIN_NUMBER}</p>
        <p><span style={{fontWeight:"700"}}>Validity </span>: Perpetual unless cancelled by SEBI or surrendered by Portfolio Manager</p>
      </div> */}

      <div className={styles.greylinecontainer}></div>
      <div style={{ paddingLeft: "6%", paddingRight: "6%" }}>
        <p style={{ color: "#97291E", fontWeight: "400" }}>
          For any query or to lodge a complaint with us, you may write to us via
          email at
          <a
            href="mailto:alt@icicipruamc.com"
            style={{ color: "#414140", fontWeight: "600" }}
            onClick={() => {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "feedbackEmail_sent",
                inquiryType: "",
                buttonName: "",
                email: "", // Encrypted email of the User using SHA-256 encryption
                contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                clientID: "",
                queryMessage: "",
                state: "",
                pageSection: "Footer Feedback Section",
                Category: "",
                FAQ: "",
              });
            }}>
            {" "}
            alt@icicipruamc.com
          </a>
        </p>
        <p style={{ color: "#97291E", fontWeight: "400" }}>
          To lodge a complaint through SEBI Complaints Redress System (SCORES),
          you can visit
          <a
            href="https://scores.sebi.gov.in/"
            target="_blank"
            style={{ color: "#414140", fontWeight: "600" }}
            onClick={() => {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "scoresLink_Click",
                inquiryType: "",
                buttonName: "SCORES Website",
                email: "", // Encrypted email of the User using SHA-256 encryption
                contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                clientID: "",
                queryMessage: "",
                state: "",
                pageSection: "",
                Category: "",
                FAQ: "",
              });
            }}>
            {" "}
            SCORES Website{" "}
          </a>
          or download SEBI SCORES Mobile App:
          <a
            href="https://play.google.com/store/apps/details?id=com.ionicframework.sebi236330"
            target="_blank"
            style={{ color: "#414140", fontWeight: "600" }}
            onClick={() => {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "googlePlay_click",
                inquiryType: "",
                buttonName: "Google Play Store",
                email: "", // Encrypted email of the User using SHA-256 encryption
                contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                clientID: "",
                queryMessage: "",
                state: "",
                pageSection: "",
                Category: "",
                FAQ: "",
              });
            }}>
            {" "}
            Google Play Store
          </a>{" "}
          |
          <a
            href="https://apps.apple.com/in/app/sebiscores/id1493257302"
            target="_blank"
            style={{ color: "#414140", fontWeight: "600" }}
            onClick={() => {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "appleApp_click",
                inquiryType: "",
                buttonName: "Apple App Store",
                email: "", // Encrypted email of the User using SHA-256 encryption
                contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                clientID: "",
                queryMessage: "",
                state: "",
                pageSection: "",
                Category: "",
                FAQ: "",
              });
            }}>
            {" "}
            Apple App Store
          </a>
        </p>
      </div>
      <div className={styles.greylinecontainer}></div>
      <div className={styles.addGrid}>
        <div className={styles.leftSubgrid}>
          <p style={{ fontSize: "18px" }}>
            ICICI Prudential Asset Management Company Limited is registered with
            SEBI as a Portfolio Manager vide registration number INP000000373
          </p>
          <p style={{ fontSize: "18px", marginTop: "-13px" }}>
            <span style={{ fontWeight: "700" }}>CIN </span>: {CIN_NUMBER}
          </p>
          <p style={{ fontSize: "18px", marginTop: "-13px" }}>
            <span style={{ fontWeight: "700" }}>Validity </span>: Perpetual
            unless cancelled by SEBI or surrendered by Portfolio Manager
          </p>
        </div>

        <div className={styles.rightSubgrid}>
          <p className={styles.grid_four_heading}>
            <b>Corresponding SEBI regional/local office address:</b>
          </p>
          <p className={styles.addInfo}>
            <b>SEBI Bhavan BKC:</b> Plot No.C4-A, &#39;G&#39; Block, Bandra
            Kurla
            <br />
            Complex, Bandra (East), Mumbai - 400051, Maharashtra
            <br />
            <b>SEBI Bhavan II BKC:</b> Plot no. C-7, ‘G’ Block, Bandra Kurla
            <br />
            Complex, Bandra(E), Mumbai - 400051, Maharashtra
          </p>
        </div>
        <div className={styles.centerSubgrid}>
          <p className={styles.grid_four_heading}>
            <b>Contact details of the Principal Officer</b>
          </p>
          <p className={styles.addInfo}>
            <b>Mr. Anand Shah</b> - CIO - PMS & AIF
            <br />
            <b>Tel</b> : +91-22-66474211
            <br />
            <b>Email</b> : principal_officer@icicipruamc.com
          </p>
        </div>
      </div>
      <div className={styles.greylinecontainer1}></div>
      <div className={styles.gridContainer}>
        <div className={styles.subGrid}>
          <p
            onClick={() => {
              handleLinkClick("/privacy-policy");
            }}
            className={styles.linksPrivacy}>
            Privacy Policy
          </p>
        </div>
        <div className={styles.subGrid}>
          <p
            onClick={() => {
              handleLinkClick("/legal-terms");
            }}
            className={styles.linksPrivacy}>
            Legal Terms
          </p>
        </div>
        <div className={styles.subGrid}>
          <p
            onClick={() => {
              handleLinkClick("/statutory-details");
            }}
            className={styles.linksPrivacy}>
            Statutory Details & Disclaimer
          </p>
        </div>
        <div className={styles.subGridRightAligned}>
          <p>
            &copy;2022 ICICI Prudential Asset Management Company. All rights
            reserved
          </p>
        </div>
      </div>

      {/* <div>
        <ul className={styles.privacy}>
          <li className={styles.linkStyle}>
            <p
              onClick={() => {
                handleLinkClick("/PrivacyPolicy");
              }}
              className={styles.linksPrivacy}
            >
              Privacy Policy
            </p>
          </li>
          <li className={styles.linkStyle}>
            <p
              onClick={() => {
                handleLinkClick("/LegalTerms");
              }}
              className={styles.linksPrivacy}
            >
              Legal Terms
            </p>
          </li>
          <li className={styles.linkStyle}>
            <p
              onClick={() => {
                handleLinkClick("/StatutoryDetails");
              }}
              className={styles.linksPrivacy}
            >
              Statutory Details & Disclaimer
            </p>
          </li>
        </ul>
              </div>
      <div className={styles.registrationnumber}>
        <p>
          ICICI Prudential Asset Management Company Limited is registered with
          SEBI as a Portfolio Manager vide registration number INP000000373
        </p>
        <p>{CIN_NUMBER}</p>
      </div>
      <div className={styles.copyright}>
        <p>
          &copy;2022 ICICI Prudential Asset Management Company. All rights
          reserved
        </p>
      </div> */}
    </div>
  );
}
